import { apiClient } from './client'

export interface MapEntity {
  id: string
  name: string
  type: string
  latitude: number
  longitude: number
  properties?: Record<string, unknown>
}

export interface TrackPoint {
  latitude: number
  longitude: number
  altitude?: number // meters above mean sea level (MSL); undefined = ground level
  timestamp: string
}

export interface GeofenceVertex {
  longitude: number
  latitude: number
  height?: number
}

export interface GeofenceCreate {
  name: string
  vertices: GeofenceVertex[]
  height: number
  infiniteHeight: boolean
  color: string
  visible?: boolean
}

export interface GeofenceResponse {
  id: string
  name: string
  vertices: GeofenceVertex[]
  height: number
  infiniteHeight: boolean
  color: string
  visible: boolean
  createdAt: string
  updatedAt: string
}

export interface GeoSourceDocument {
  id: string
  filename: string
  file_type: string
}

export const geolocationApi = {
  getGeoSources: (caseId: string) =>
    apiClient.get<GeoSourceDocument[]>(`/cases/${caseId}/geolocation/sources`),

  getEntities: (caseId: string, documentIds?: string[]) => {
    const params = documentIds?.length ? `?document_ids=${documentIds.join(',')}` : ''
    return apiClient.get<MapEntity[]>(`/cases/${caseId}/geolocation${params}`)
  },

  getEntityTrack: (caseId: string, entityId: string, documentIds?: string[]) => {
    const params = documentIds?.length ? `?document_ids=${documentIds.join(',')}` : ''
    return apiClient.get<TrackPoint[]>(`/cases/${caseId}/geolocation/${entityId}/track${params}`)
  },

  // Geofences
  getGeofences: (caseId: string) => apiClient.get<GeofenceResponse[]>(`/cases/${caseId}/geofences`),

  createGeofence: (caseId: string, data: GeofenceCreate) =>
    apiClient.post<GeofenceResponse>(`/cases/${caseId}/geofences`, data),

  updateGeofence: (caseId: string, geofenceId: string, data: Partial<GeofenceCreate>) =>
    apiClient.put<GeofenceResponse>(`/cases/${caseId}/geofences/${geofenceId}`, data),

  deleteGeofence: (caseId: string, geofenceId: string) =>
    apiClient.delete(`/cases/${caseId}/geofences/${geofenceId}`),
}
